/**
 * Stored values for `app/v1/surveyWorks` document field `status` (Firestore).
 * Several values represent an internal pipeline; the UI shows them as one "in progress" state.
 */
export const SURVEY_WORK_STATUS = {
  NEW: 'new',
  IN_PROGRESS: 'inProgress',
  PENDING_REVISION: 'pendingRevision',
  REVIEWING: 'reviewing',
  COMPLETED: 'completed'
}

/** Firestore values that share the same chip label and style as {@link SURVEY_WORK_STATUS.IN_PROGRESS}. */
const UI_IN_PROGRESS_GROUP = new Set([
  SURVEY_WORK_STATUS.IN_PROGRESS,
  SURVEY_WORK_STATUS.PENDING_REVISION,
  SURVEY_WORK_STATUS.REVIEWING
])

/** Legacy Firestore values grouped with in-progress in the UI. */
const LEGACY_IN_PROGRESS_ALIASES = new Set(['assigned', 'inReview'])

/**
 * @typedef {'new'|'inProgress'|'completed'} SurveyWorkUiStatus
 */

/**
 * Maps raw Firestore status to a UI bucket (i18n key + CSS class suffix).
 *
 * @param {string|undefined|null} raw
 * @returns {SurveyWorkUiStatus}
 */
export function surveyWorkStatusToUi (raw) {
  const s = raw != null && String(raw).trim() !== '' ? String(raw) : SURVEY_WORK_STATUS.NEW
  if (UI_IN_PROGRESS_GROUP.has(s) || LEGACY_IN_PROGRESS_ALIASES.has(s)) {
    return SURVEY_WORK_STATUS.IN_PROGRESS
  }
  if (s === SURVEY_WORK_STATUS.COMPLETED) {
    return SURVEY_WORK_STATUS.COMPLETED
  }
  if (s === SURVEY_WORK_STATUS.NEW) {
    return SURVEY_WORK_STATUS.NEW
  }
  return SURVEY_WORK_STATUS.NEW
}



// WEBPACK FOOTER //
// ./src/lib/surveyWorkStatus.js